
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.57.336v2.36h-.765a6.325 6.325 0 00-.336-.86 1.7 1.7 0 00-.336-.5.953.953 0 00-.406-.242 2.21 2.21 0 00-.618-.07H2.82v4.078h4.188v.859H2.82v3.062c0 .428.032.735.094.922a.84.84 0 00.281.414c.125.094.365.18.72.258V11H.444v-.383c.323-.083.54-.174.649-.273.11-.104.18-.25.21-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 00.445.72V.336H7.57z","fill":"currentColor"}})])
          )
        }
      }
    